import { createStyles } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = () =>
  createStyles({
    root: {
      width: '100%',
      height: '100%',
      position: 'relative',
    },
    pagination: {
      position: 'absolute',
      width: '60% !important',
      bottom: '15px !important',
      left: '50% !important',
      marginLeft: '-30% !important',
    },
    paginationGallery: {
      bottom: `40px !important`,
    },
    previewCarousel: {
      position: 'relative',
    },
    image: {
      display: 'block',
      height: 250,
      width: '100%',
      objectFit: 'cover',
    },
    fullImage: {
      display: 'block',
      height: 700,
      width: '100%',
      objectFit: 'cover',
    },
    gallery: {
      position: 'absolute',
      right: 5,
      bottom: 5,
      borderRadius: 4,
      padding: '8px 12px',
      color: colors.blue.darkish,
      backgroundColor: colors.blue.light,
      display: 'flex',
      alignItems: 'center',
      userSelect: 'none',
      zIndex: 2,

      '&:hover': {
        cursor: 'pointer',
      },
    },
    galleryImage: {
      blockSize: '16px',
      fontSize: 14,
      color: colors.blue.darkish,
    },
    galleryLabel: {
      paddingLeft: 5,
      fontSize: 12,
    },
    dialog: {
      width: '100%',
      maxWidth: 1000,
    },
    headerIcon: {
      fontSize: 18,
      color: colors.grey.lightish,
    },
    headerBtn: {
      minWidth: 38,
      width: 38,
      position: 'absolute',
      right: 5,
      top: 5,
      zIndex: 2,
    },
    headerBtnSmall: {
      padding: '8px 9px',
    },
  });
